import React from "react";

const steps = [
    { n: "01", title: "Sourcing", body: "Direct contracts with farmer collectives across Gujarat & Maharashtra. We pay premiums for produce harvested at peak ripeness." },
    { n: "02", title: "Sort & wash", body: "Hand-grading on-line. Triple wash with food-grade water. No bleach, no chlorine, no surface coatings." },
    { n: "03", title: "Drying", body: "Spray drying, vacuum dehydration or low-temp tray drying — chosen per ingredient to retain colour, aroma & nutrition." },
    { n: "04", title: "Cryo-mill", body: "Particle size from 80 to 200 mesh — milled cold to lock essential oils. No anti-caking agents added." },
    { n: "05", title: "QC & lab", body: "Every batch tested for moisture, microbiology, pesticide residue and heavy metals before release." },
    { n: "06", title: "Pack & ship", body: "Triple-laminate retail pouches · multi-wall paper sacks (15/25 kg) · sealed, palletised, export-ready." },
];

const Process = () => {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="py-24 md:py-36 bg-sun-ink text-sun-bg relative overflow-hidden"
        >
            {/* Decorative sun */}
            <div className="absolute -top-40 -right-40 w-[36rem] h-[36rem] sun-rays opacity-20 animate-spin-slow pointer-events-none" />
            <div className="absolute top-20 right-20 w-72 h-72 rounded-full bg-sunrise opacity-30 blur-3xl pointer-events-none" />

            <div className="container-x relative">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20 border-b border-white/15 pb-8">
                    <div>
                        <div className="overline text-sun-goldSoft mb-6">— The Craft</div>
                        <h2 className="font-heading text-5xl md:text-7xl lg:text-[7.5rem] leading-[0.95] tracking-[-0.02em]">
                            From field
                            <br />
                            <span className="display-italic text-gradient">to sealed pouch</span>
                            <br />
                            in 36 hours.
                        </h2>
                    </div>
                    <p className="md:max-w-sm text-white/70 text-sm leading-relaxed">
                        Our facility lives by a single rule: never let a fruit or vegetable
                        wait. The faster we dry, the more nutrition stays in the powder.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {steps.map((s) => (
                        <div
                            key={s.n}
                            data-testid={`process-step-${s.n}`}
                            className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-10 hover:bg-white/10 hover:border-sun-orange/40 transition-all duration-500 group relative"
                        >
                            <div className="flex items-start justify-between mb-8">
                                <div className="font-mono text-xs uppercase tracking-[0.32em] text-sun-goldSoft">
                                    Step / {s.n}
                                </div>
                                <div className="w-10 h-10 rounded-full bg-sunrise flex items-center justify-center text-white text-sm font-medium group-hover:scale-110 transition-transform">
                                    {s.n}
                                </div>
                            </div>
                            <h3 className="font-heading text-3xl md:text-4xl leading-[1.05] tracking-tight">
                                {s.title}
                            </h3>
                            <p className="mt-4 text-white/70 leading-relaxed text-sm md:text-base max-w-md">
                                {s.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
